import { render, staticRenderFns } from "./SaleFromUrl.vue?vue&type=template&id=0688bfd4&scoped=true"
import script from "./SaleFromUrl.vue?vue&type=script&lang=ts"
export * from "./SaleFromUrl.vue?vue&type=script&lang=ts"
import style0 from "./SaleFromUrl.vue?vue&type=style&index=0&id=0688bfd4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688bfd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0688bfd4')) {
      api.createRecord('0688bfd4', component.options)
    } else {
      api.reload('0688bfd4', component.options)
    }
    module.hot.accept("./SaleFromUrl.vue?vue&type=template&id=0688bfd4&scoped=true", function () {
      api.rerender('0688bfd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SaleFromUrl.vue"
export default component.exports